import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DcpFormatDataService {

  /**
   * This method makes sure there is a trailing slash in every given url and returns the formatted string.
   *
   * @param url formatted url string
   */
  public formatUrl(url: string): string {
    return url.replace(/\/?(\?|#|$)/, '/$1');
  }
}
